// extracted by css-extract-rspack-plugin
export default {"row":"j02ib","wrap":"AWl6X"};